import { OiamEvents } from '@oiambk/oiam-oauth-types';
import log from 'loglevel';

export class OauthEventService {
  static STATE_QUEUE_EVENT = 'oiamStateChangeEvent';
  static CONFIGURED_EVENT = 'oiamConfiguredEvent';
  private static configured = false;

  // spaming events should terminate after 30min
  private static MAX_ATTEMPTS_SEND_LOADED = 95;
  private static eventTimer: NodeJS.Timeout | undefined = undefined;

  public static doDispatchEvent(event: string, data?: any) {
    log.debug('oiam-oauth-wc: dispatch event', event);
    // loaded event as interval to handle async loading of components
    if (event === OiamEvents.LOADED) {
      this.startSendLoadedEventWithExponentialBackoff();
    } else {
      this.sendEvent(event, data);
    }
  }

  public static startSendLoadedEventWithExponentialBackoff() {
    this.sendEvent(OiamEvents.LOADED, true);
    this.sendLoadedPeriodicallyUntilConfigured(1);
  }

  public static stopLoadedEventIfConfigured() {
    log.debug(`stop emitting ${OiamEvents.LOADED}, we've been configured`);
    clearTimeout(this.eventTimer);
    this.configured = true;
  }

  public static async sendBeforeNavigationEventWithWait(waittime: number = 20) {
    this.doDispatchEvent(OiamEvents.BEFORENAVIGATION);
    return new Promise(resolve => setTimeout(resolve, waittime));
  }

  private static sendLoadedPeriodicallyUntilConfigured(currentAttempt: number) {
    if (this.configured) {
      return;
    }
    // base value 1.095 results in min 50 events in the first minute
    const currentDelay = 20 * Math.pow(1.095, currentAttempt - 1);
    this.eventTimer = setTimeout(() => {
      if (currentAttempt > this.MAX_ATTEMPTS_SEND_LOADED) {
        log.warn('Missing oiamSetConfigEvent, oiam-oauth-wc cannot work without it.');
      } else {
        this.sendEvent(OiamEvents.LOADED, true);
        this.sendLoadedPeriodicallyUntilConfigured(++currentAttempt);
      }
    }, currentDelay);
  }

  private static sendEvent(event: string, data?: any) {
    window.self.dispatchEvent(
      new CustomEvent(event, {
        bubbles: true,
        composed: true,
        detail: data,
      }),
    );
  }
}
